export default "__VITE_ASSET__BuAdCgm3__"